export const newsFeed = 'feed';
